import { createSelector } from 'reselect';

export const getTeamSettingsMap = state => {
    const { teamSettings } = state;
    return teamSettings.get('teamSettingsMap');
};

export const isTeamSettingsFetchInProgress = state => {
    const { teamSettings } = state;
    return teamSettings.get('isLoading');
};

export const getTeamSettingsForBatchUpload = createSelector(
    [state => state.team],
    teamState => {
        // we are using teamSettings from state.teamSettings in other places
        return teamState.getIn(['records', 'teamSettings', 'entity']);
    }
);

export const isTeamSettingsForBatchUploadLoading = createSelector(
    [state => state.team],
    teamState => {
        return teamState.getIn(['records', 'teamSettings', 'inProgress']);
    }
);

export const getTaskProfileForBatchUpload = createSelector(
    [state => state.team],
    teamState => {
        return teamState.getIn(['records', 'taskProfile', 'entity']);
    }
);

export const isTaskProfileForBatchUploadLoading = createSelector(
    [state => state.team],
    teamState => {
        return teamState.getIn(['records', 'taskProfile', 'inProgress']);
    }
);

export const getTaskProfileBatchUploadError = createSelector(
    [state => state.team],
    teamState => {
        return teamState.getIn(['records', 'taskProfile', 'hasError']);
    }
);

export const getTeamSettingsBatchUploadError = createSelector(
    [state => state.team],
    teamState => {
        return teamState.getIn(['records', 'teamSettings', 'hasError']);
    }
);

export { getTeamSettingsForBatchUpload as getTeamSettingsForBatch };
export { isTeamSettingsForBatchUploadLoading as isTeamSettingsForBatchLoading };
